import React from "react";
import { Menu, Item, Separator } from "react-contexify";
import screener from "../../assets/images/contextMenu/screener.png";
import contact_me from "../../assets/images/contextMenu/contact_me.png";
import refresh from "../../assets/images/contextMenu/refresh.png";
import twitter from "../../assets/images/contextMenu/x.png";
import credits from "../../assets/images/contextMenu/credits.png";
import telegram from "../../assets/images/contextMenu/telegram.png";
import { SCREENS } from "../../utils/documents/enums";
import Credits from "../base/credits";
import { useBoolean } from "@fluentui/react-hooks";

const MENU_ID = "context-menu";

function DesktopContextMenu(props) {
	const handleRefresh = ({ event, props }) =>
		console.log("Super Refreshed !!");
	const navigate = (link) => {
		window.open(link, "_blank");
	};

	const [isModalOpen, { setTrue: showModal, setFalse: hideModal }] =
		useBoolean(false);
	return (
		<div>
			<Menu id={MENU_ID}>
				<Item
					onClick={() =>
						navigate(
							"https://dexscreener.com/solana/3tep1n7tgr9rauv11zjmd7gq27tdgquynu3mcsvf9ze1"
						)
					}
				>
					<img
						src={screener}
						width="30"
						height="30"
						className="uk-margin-small-right"
						alt="Star"
					/>
					View This Project
				</Item>
				<Separator />
				{props.location === SCREENS.DESKTOP && (
					<Item onClick={handleRefresh}>
						<img
							src={refresh}
							width="30"
							height="30"
							className="uk-margin-small-right"
							alt="Refresh"
						/>
						Refresh
					</Item>
				)}
				{props.location === SCREENS.DESKTOP && <Separator />}
				<Item
					onClick={() =>
						navigate(
							"https://x.com/muradcult6900"
						)
					}
				>
					<img
						src={twitter}
						width="30"
						height="30"
						className="uk-margin-small-right"
						alt="Code"
					/>
					Follow On X
				</Item>
				<Separator />
				<Item
					onClick={() =>
						navigate("https://t.me/muradcult6900")
					}
				>
					<img
						src={telegram}
						width="30"
						height="30"
						className="uk-margin-small-right"
						alt="Github"
					/>
					Join Telegram
				</Item>
				<Separator />
				<Item
					onClick={() =>
						navigate("mailto:muradcultteam@gmail.com")
					}
				>
					<img
						src={contact_me}
						width="30"
						height="30"
						className="uk-margin-small-right"
						alt="mail"
					/>
					Contact Us
				</Item>
				<Separator />
				<Item onClick={showModal}>
					<img
						src={credits}
						width="30"
						height="30"
						className="uk-margin-small-right"
						alt="Credits"
					/>
					Credits
				</Item>
				<Separator />
			</Menu>
			<Credits isModalOpen={isModalOpen} hideModal={hideModal} />
		</div>
	);
}

export default DesktopContextMenu;
